// // import React from "react";

// // const JobApplicationForm = () => {
// //   return (
// //     <div className="flex justify-center items-center min-h-screen bg-white px-4">
// //       <form className="w-full lg:w-[90%] space-y-6">
// //         <h1 className="text-4xl font-bold text-gray-800">Job Application</h1>

// //         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
// //           <input
// //             type="text"
// //             placeholder="First Name"
// //             className="border border-gray-300 px-4 py-4 w-full rounded-md"
// //           />
// //           <input
// //             type="text"
// //             placeholder="Last Name"
// //             className="border border-gray-300 px-4 py-4 w-full rounded-md"
// //           />
// //         </div>

// //         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
// //           <input
// //             type="email"
// //             placeholder="Email Address"
// //             className="border border-gray-300 px-4 py-4 w-full rounded-md"
// //           />
// //           <input
// //             type="text"
// //             placeholder="Phone"
// //             className="border border-gray-300 px-4 py-4 w-full rounded-md"
// //           />
// //         </div>

// //         <input
// //           type="text"
// //           placeholder="What position are you applying for?"
// //           className="border border-gray-300 px-4 py-4 w-full rounded-md"
// //         />

// //         <input
// //           type="file"
// //           className="file:mr-4 file:py-2 file:px-4 file:border-0 file:bg-gray-100 file:rounded-md file:text-sm text-gray-700"
// //         />

// //         <input
// //           type="text"
// //           placeholder="URL"
// //           className="border border-gray-300 px-4 py-4 w-full rounded-md"
// //         />

// //         <button
// //           type="submit"
// //           className="bg-gradient-to-b from-[#1BB095] to-teal-900 text-white px-6 py-2 rounded-md"
// //         >
// //           Submit
// //         </button>
// //       </form>
// //     </div>
// //   );
// // };

// // export default JobApplicationForm;


// import React, { useState } from 'react';
// import { User, Mail, Phone, Briefcase, Upload, Link, MapPin, Calendar, FileText, CheckCircle } from 'lucide-react';

// const JobApplicationForm = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     position: '',
//     resume: null,
//     portfolioUrl: '',
//     address: '',
//     availableDate: '',
//     coverLetter: '',
//     experience: '',
//     salary: ''
//   });

//   const [errors, setErrors] = useState({});
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value, files } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: files ? files[0] : value
//     }));
    
//     // Clear error when user starts typing
//     if (errors[name]) {
//       setErrors(prev => ({ ...prev, [name]: '' }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
    
//     if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
//     if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
//     if (!formData.email.trim()) {
//       newErrors.email = 'Email is required';
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = 'Email is invalid';
//     }
//     if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
//     if (!formData.position.trim()) newErrors.position = 'Position is required';
//     if (!formData.experience) newErrors.experience = 'Experience level is required';
//     if (!formData.availableDate) newErrors.availableDate = 'Available start date is required';
    
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const newErrors = validateForm();
    
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return;
//     }
    
//     setIsSubmitting(true);
    
//     // Simulate API call
//     setTimeout(() => {
//       setIsSubmitted(true);
//       setIsSubmitting(false);
//       console.log('Form submitted:', formData);
//     }, 2000);
//   };

//   if (isSubmitted) {
//     return (
//       <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
//         <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md text-center">
//           <CheckCircle className="mx-auto mb-4 text-green-500" size={64} />
//           <h2 className="text-2xl font-bold text-gray-800 mb-2">Application Submitted!</h2>
//           <p className="text-gray-600 mb-6">Thank you for your application. We'll review it and get back to you soon.</p>
//           <button 
//             onClick={() => {
//               setIsSubmitted(false);
//               setFormData({
//                 firstName: '', lastName: '', email: '', phone: '', position: '',
//                 resume: null, portfolioUrl: '', address: '', availableDate: '',
//                 coverLetter: '', experience: '', salary: ''
//               });
//             }}
//             className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200"
//           >
//             Submit Another Application
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4">
//       <div className="max-w-4xl mx-auto">
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h1 className="text-5xl font-bold text-gray-800 mb-4">Job Application</h1>
//           <p className="text-xl text-gray-600">Join our team and make a difference</p>
//           <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-indigo-600 mx-auto mt-4 rounded-full"></div>
//         </div>

//         {/* Form */}
//         <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 space-y-8">
//           {/* Personal Information Section */}
//           <div>
//             <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
//               <User className="mr-3 text-blue-600" size={28} />
//               Personal Information
//             </h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">First Name *</label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   placeholder="Enter your first name"
//                   className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 ${
//                     errors.firstName ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-gray-300'
//                   }`}
//                 />
//                 {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Last Name *</label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleInputChange}
//                   placeholder="Enter your last name"
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 ${
//                     errors.lastName ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-gray-300'
//                   }`}
//                 />
//                 {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
//               </div>
//             </div>
//           </div>

//           {/* Contact Information */}
//           <div>
//             <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
//               <Mail className="mr-3 text-blue-600" size={28} />
//               Contact Information
//             </h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address *</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   placeholder="your.email@example.com"
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 ${
//                     errors.email ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-gray-300'
//                   }`}
//                 />
//                 {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number *</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   placeholder="+92 300 1234567"
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 ${
//                     errors.phone ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-gray-300'
//                   }`}
//                 />
//                 {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
//               </div>
//             </div>
            
//             <div className="mt-6">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">Address</label>
//               <input
//                 type="text"
//                 name="address"
//                 value={formData.address}
//                 onChange={handleInputChange}
//                 placeholder="Your full address"
//                 className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-gray-300 transition-all duration-200"
//               />
//             </div>
//           </div>

//           {/* Job Details */}
//           <div>
//             <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
//               <Briefcase className="mr-3 text-blue-600" size={28} />
//               Job Details
//             </h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Position Applying For *</label>
//                 <input
//                   type="text"
//                   name="position"
//                   value={formData.position}
//                   onChange={handleInputChange}
//                   placeholder="e.g., Frontend Developer"
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 ${
//                     errors.position ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-gray-300'
//                   }`}
//                 />
//                 {errors.position && <p className="text-red-500 text-sm mt-1">{errors.position}</p>}
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Experience Level *</label>
//                 <select
//                   name="experience"
//                   value={formData.experience}
//                   onChange={handleInputChange}
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 ${
//                     errors.experience ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-gray-300'
//                   }`}
//                 >
//                   <option value="">Select experience level</option>
//                   <option value="entry">Entry Level (0-2 years)</option>
//                   <option value="mid">Mid Level (2-5 years)</option>
//                   <option value="senior">Senior Level (5+ years)</option>
//                   <option value="executive">Executive Level</option>
//                 </select>
//                 {errors.experience && <p className="text-red-500 text-sm mt-1">{errors.experience}</p>}
//               </div>
//             </div>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Available Start Date *</label>
//                 <input
//                   type="date"
//                   name="availableDate"
//                   value={formData.availableDate}
//                   onChange={handleInputChange}
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 ${
//                     errors.availableDate ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-gray-300'
//                   }`}
//                 />
//                 {errors.availableDate && <p className="text-red-500 text-sm mt-1">{errors.availableDate}</p>}
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Expected Salary</label>
//                 <input
//                   type="text"
//                   name="salary"
//                   value={formData.salary}
//                   onChange={handleInputChange}
//                   placeholder="e.g., PKR 80,000 - 120,000"
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-gray-300 transition-all duration-200"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Documents */}
//           <div>
//             <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
//               <Upload className="mr-3 text-blue-600" size={28} />
//               Documents & Links
//             </h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Resume/CV</label>
//                 <input
//                   type="file"
//                   name="resume"
//                   onChange={handleInputChange}
//                   accept=".pdf,.doc,.docx"
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-gray-300 transition-all duration-200 file:mr-4 file:py-2 file:px-4 file:border-0 file:bg-blue-100 file:text-blue-700 file:rounded-lg file:text-sm file:font-medium"
//                 />
//                 <p className="text-xs text-gray-500 mt-1">Accepted formats: PDF, DOC, DOCX (Max 5MB)</p>
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Portfolio/LinkedIn URL</label>
//                 <input
//                   type="url"
//                   name="portfolioUrl"
//                   value={formData.portfolioUrl}
//                   onChange={handleInputChange}
//                   placeholder="https://your-portfolio.com"
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-gray-300 transition-all duration-200"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Cover Letter */}
//           <div>
//             <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
//               <FileText className="mr-3 text-blue-600" size={28} />
//               Cover Letter
//             </h2>
            
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">Tell us why you're interested in this position</label>
//               <textarea
//                 name="coverLetter"
//                 value={formData.coverLetter}
//                 onChange={handleInputChange}
//                 placeholder="Share your motivation, relevant experience, and what makes you a great fit for this role..."
//                 rows={6}
//                 className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-gray-300 transition-all duration-200 resize-none"
//               />
//             </div>
//           </div>

//           {/* Submit Button */}
//           <div className="pt-6">
//             <button
//               type="submit"
//               disabled={isSubmitting}
//               onClick={handleSubmit}
//               className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-4 px-8 rounded-xl transition-all duration-200 transform hover:scale-[1.02] disabled:scale-100 disabled:cursor-not-allowed shadow-lg hover:shadow-xl"
//             >
//               {isSubmitting ? (
//                 <div className="flex items-center justify-center">
//                   <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent mr-3"></div>
//                   Submitting Application...
//                 </div>
//               ) : (
//                 'Submit Application'
//               )}
//             </button>
//           </div>

//           <p className="text-xs text-gray-500 text-center mt-4">
//             By submitting this form, you agree to our privacy policy and terms of service.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default JobApplicationForm;


// import React, { useState } from "react";
// import { HardHat, User, Mail, Phone, Calendar, MapPin, FileText, Building2, Wrench, Shield } from "lucide-react";

// const JobApplicationForm = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     position: '',
//     experience: '',
//     previousWork: '',
//     certifications: '',
//     availableDate: '',
//     shiftPreference: '',
//     address: '',
//     emergencyContact: '',
//     emergencyPhone: '',
//     resume: null,
//     safetyTraining: '',
//     workLocation: '',
//     expectedSalary: '',
//     references: ''
//   });

//   const [errors, setErrors] = useState({});
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const constructionPositions = [
//     'Site Engineer', 'Project Manager', 'Foreman', 'Mason', 'Carpenter', 
//     'Electrician', 'Plumber', 'Heavy Equipment Operator', 'Welder', 
//     'Safety Officer', 'Labor/Helper', 'Surveyor', 'Architect', 'Civil Engineer'
//   ];

//   const handleInputChange = (e) => {
//     const { name, value, files } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: files ? files[0] : value
//     }));
    
//     if (errors[name]) {
//       setErrors(prev => ({ ...prev, [name]: '' }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
    
//     if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
//     if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
//     if (!formData.email.trim()) {
//       newErrors.email = 'Email is required';
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = 'Email is invalid';
//     }
//     if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
//     if (!formData.position) newErrors.position = 'Position is required';
//     if (!formData.experience) newErrors.experience = 'Experience level is required';
//     if (!formData.availableDate) newErrors.availableDate = 'Available start date is required';
    
//     return newErrors;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newErrors = validateForm();
    
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return;
//     }
    
//     setIsSubmitted(true);
//     console.log('Construction Job Application:', formData);
//   };

//   if (isSubmitted) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-orange-50 to-yellow-100 flex items-center justify-center px-4">
//         <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md text-center">
//           <HardHat className="mx-auto mb-4 text-[#1BB095]" size={64} />
//           <h2 className="text-2xl font-bold text-gray-800 mb-2">Application Submitted!</h2>
//           <p className="text-gray-600 mb-6">Thank you for applying to join our construction team. We'll review your application and contact you soon.</p>
//           <button 
//             onClick={() => {
//               setIsSubmitted(false);
//               setFormData({
//                 firstName: '', lastName: '', email: '', phone: '', position: '',
//                 experience: '', previousWork: '', certifications: '', availableDate: '',
//                 shiftPreference: '', address: '', emergencyContact: '', emergencyPhone: '',
//                 resume: null, safetyTraining: '', workLocation: '', expectedSalary: '', references: ''
//               });
//             }}
//             className="bg-gradient-to-r from-orange-600 to-red-600 text-white px-6 py-3 rounded-lg hover:from-orange-700 hover:to-red-700 transition-all duration-200"
//           >
//             Submit Another Application
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-[#1BB095]/10 to-teal-900/10 py-12 px-4">
//   <div className="max-w-5xl mx-auto">
//     {/* Header */}
//     <div className="text-center mb-12">
//       <div className="flex justify-center items-center mb-4">
//         <Building2 className="text-[#1BB095] mr-4" size={48} />
//         <HardHat className="text-teal-900" size={48} />
//       </div>
//       <h1 className="text-5xl font-bold text-gray-800 mb-4">Join Our Construction Team</h1>
//       <p className="text-xl text-gray-600">
//         Build your career with Pakistan's leading construction company
//       </p>
//       <div className="w-32 h-1 bg-gradient-to-r from-[#1BB095] to-teal-900 mx-auto mt-4 rounded-full"></div>
//     </div>

//         {/* Form */}
//         <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 space-y-10">
//           {/* Personal Information */}
//           <div>
//             <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
//               <User className="mr-3 text-[#1BB095]" size={32} />
//               Personal Information
//             </h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">First Name *</label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   placeholder="Enter first name"
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-200 ${
//                     errors.firstName ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-orange-300'
//                   }`}
//                 />
//                 {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Last Name *</label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleInputChange}
//                   placeholder="Enter last name"
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-200 ${
//                     errors.lastName ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-orange-300'
//                   }`}
//                 />
//                 {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
//               </div>
//             </div>
//           </div>

//           {/* Contact Information */}
//           <div>
//             <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
//               <Phone className="mr-3 text-[#1BB095]" size={32} />
//               Contact Details
//             </h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address *</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   placeholder="your.email@example.com"
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-200 ${
//                     errors.email ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-orange-300'
//                   }`}
//                 />
//                 {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number *</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   placeholder="+92 300 1234567"
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-200 ${
//                     errors.phone ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-orange-300'
//                   }`}
//                 />
//                 {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
//               </div>
//             </div>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Full Address</label>
//                 <input
//                   type="text"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleInputChange}
//                   placeholder="Complete address with city"
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200"
//                 />
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Preferred Work Location</label>
//                 <select
//                   name="workLocation"
//                   value={formData.workLocation}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200"
//                 >
//                   <option value="">Select location</option>
//                   <option value="lahore">Lahore</option>
//                   <option value="karachi">Karachi</option>
//                   <option value="islamabad">Islamabad</option>
//                   <option value="faisalabad">Faisalabad</option>
//                   <option value="rawalpindi">Rawalpindi</option>
//                   <option value="multan">Multan</option>
//                   <option value="anywhere">Any location</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           {/* Job Details */}
//           <div>
//             <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
//               <Wrench className="mr-3 text-[#1BB095]" size={32} />
//               Job Information
//             </h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Position Applied For *</label>
//                 <select
//                   name="position"
//                   value={formData.position}
//                   onChange={handleInputChange}
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-200 ${
//                     errors.position ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-orange-300'
//                   }`}
//                 >
//                   <option value="">Select position</option>
//                   {constructionPositions.map(pos => (
//                     <option key={pos} value={pos}>{pos}</option>
//                   ))}
//                 </select>
//                 {errors.position && <p className="text-red-500 text-sm mt-1">{errors.position}</p>}
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Experience Level *</label>
//                 <select
//                   name="experience"
//                   value={formData.experience}
//                   onChange={handleInputChange}
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-200 ${
//                     errors.experience ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-orange-300'
//                   }`}
//                 >
//                   <option value="">Select experience</option>
//                   <option value="fresh">Fresh/No Experience</option>
//                   <option value="1-2">1-2 Years</option>
//                   <option value="3-5">3-5 Years</option>
//                   <option value="6-10">6-10 Years</option>
//                   <option value="10+">10+ Years</option>
//                 </select>
//                 {errors.experience && <p className="text-red-500 text-sm mt-1">{errors.experience}</p>}
//               </div>
//             </div>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Available Start Date *</label>
//                 <input
//                   type="date"
//                   name="availableDate"
//                   value={formData.availableDate}
//                   onChange={handleInputChange}
//                   className={`w-full px-4 py-4 border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-200 ${
//                     errors.availableDate ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-orange-300'
//                   }`}
//                 />
//                 {errors.availableDate && <p className="text-red-500 text-sm mt-1">{errors.availableDate}</p>}
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Shift Preference</label>
//                 <select
//                   name="shiftPreference"
//                   value={formData.shiftPreference}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200"
//                 >
//                   <option value="">Select shift</option>
//                   <option value="day">Day Shift (8 AM - 6 PM)</option>
//                   <option value="night">Night Shift (6 PM - 6 AM)</option>
//                   <option value="flexible">Flexible</option>
//                   <option value="overtime">Available for Overtime</option>
//                 </select>
//               </div>
//             </div>
            
//             <div className="mt-6">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">Expected Monthly Salary (PKR)</label>
//               <input
//                 type="text"
//                 name="expectedSalary"
//                 value={formData.expectedSalary}
//                 onChange={handleInputChange}
//                 placeholder="e.g., 30,000 - 50,000"
//                 className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200"
//               />
//             </div>
//           </div>

//           {/* Safety & Certifications */}
//           <div>
//             <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
//               <Shield className="mr-3 text-[#1BB095]" size={32} />
//               Safety & Qualifications
//             </h2>
            
//             <div className="space-y-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Safety Training & Certifications</label>
//                 <textarea
//                   name="safetyTraining"
//                   value={formData.safetyTraining}
//                   onChange={handleInputChange}
//                   placeholder="List any safety certifications, training courses, or safety-related experience you have..."
//                   rows={3}
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200 resize-none"
//                 />
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Professional Certifications & Skills</label>
//                 <textarea
//                   name="certifications"
//                   value={formData.certifications}
//                   onChange={handleInputChange}
//                   placeholder="List relevant certifications, technical skills, equipment you can operate..."
//                   rows={3}
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200 resize-none"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Experience Details */}
//           <div>
//             <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
//               <FileText className="mr-3 text-[#1BB095]" size={32} />
//               Work Experience
//             </h2>
            
//             <div className="space-y-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Previous Construction Work Experience</label>
//                 <textarea
//                   name="previousWork"
//                   value={formData.previousWork}
//                   onChange={handleInputChange}
//                   placeholder="Describe your previous construction experience, projects worked on, companies, duration..."
//                   rows={4}
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200 resize-none"
//                 />
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">References (Name, Position, Contact)</label>
//                 <textarea
//                   name="references"
//                   value={formData.references}
//                   onChange={handleInputChange}
//                   placeholder="Provide 2-3 professional references from previous employers or supervisors..."
//                   rows={3}
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200 resize-none"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Emergency Contact */}
//           <div>
//             <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
//               <MapPin className="mr-3 text-[#1BB095]" size={32} />
//               Emergency Contact
//             </h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Emergency Contact Name</label>
//                 <input
//                   type="text"
//                   name="emergencyContact"
//                   value={formData.emergencyContact}
//                   onChange={handleInputChange}
//                   placeholder="Full name of emergency contact"
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200"
//                 />
//               </div>
              
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Emergency Contact Phone</label>
//                 <input
//                   type="tel"
//                   name="emergencyPhone"
//                   value={formData.emergencyPhone}
//                   onChange={handleInputChange}
//                   placeholder="+92 300 1234567"
//                   className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 hover:border-orange-300 transition-all duration-200"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Resume Upload */}
//         <div>
//   <label className="block text-sm font-semibold text-gray-700 mb-2">
//     Upload Resume/CV
//   </label>
//   <input
//     type="file"
//     name="resume"
//     onChange={handleInputChange}
//     accept=".pdf,.doc,.docx"
//     className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl 
//                focus:outline-none focus:ring-2 focus:ring-[#1BB095] 
//                hover:border-[#1BB095] transition-all duration-200 
//                file:mr-4 file:py-2 file:px-4 file:border-0 
//                file:bg-gradient-to-r file:from-[#1BB095] file:to-teal-900 
//                file:text-white file:rounded-lg file:text-sm file:font-medium 
//                file:cursor-pointer"
//   />
//   <p className="text-xs text-gray-500 mt-1">
//     Accepted formats: PDF, DOC, DOCX (Max 5MB)
//   </p>
// </div>


//           {/* Submit Button */}
//           <div className="pt-8">
//             <button
//               type="submit"
//               onClick={handleSubmit}
//                  className="w-full bg-gradient-to-r from-[#1BB095] to-teal-900 
//                    hover:from-teal-700 hover:to-teal-900 text-white 
//                    font-bold py-5 px-8 rounded-xl transition-all 
//                    duration-200 transform hover:scale-[1.02] 
//                    shadow-lg hover:shadow-xl text-lg"
//             >
//               Submit Job Application
//             </button>
//           </div>

//           <p className="text-sm text-gray-500 text-center mt-4">
//             All information provided will be kept confidential and used only for recruitment purposes.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default JobApplicationForm;



import React, { useState , useRef} from "react";
import {
  HardHat,
  User,
  Phone,
  FileText,
  Building2,
  Wrench,
  Shield,
  MapPin,
} from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const JobApplicationForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    position: "",
    experience: "",
    previousWork: "",
    certifications: "",
    availableDate: "",
    shiftPreference: "",
    address: "",
    emergencyContact: "",
    emergencyPhone: "",
    resume: null,
    safetyTraining: "",
    workLocation: "",
    expectedSalary: "",
    references: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
   
  
  const constructionPositions = [
    "Site Engineer",
    "Project Manager",
    "Foreman",
    "Mason",
    "Carpenter",
    "Electrician",
    "Plumber",
    "Heavy Equipment Operator",
    "Welder",
    "Safety Officer",
    "Labor/Helper",
    "Surveyor",
    "Architect",
    "Civil Engineer",
  ];

  // Handle input
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Validation
  const validateForm = () => {
    const newErrors = {};
    

    // Required fields
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    if (!formData.position) newErrors.position = "Position is required";
    if (!formData.experience) newErrors.experience = "Experience level is required";
    if (!formData.availableDate) newErrors.availableDate = "Available start date is required";

    if (!formData.address.trim()) newErrors.address = "Address is required";
    if (!formData.workLocation) newErrors.workLocation = "Preferred work location is required";

    if (!formData.expectedSalary.trim()) newErrors.expectedSalary = "Expected salary is required";

    if (!formData.previousWork.trim())
      newErrors.previousWork = "Work experience details are required";

    if (!formData.references.trim())
      newErrors.references = "References are required";

    if (!formData.emergencyContact.trim())
      newErrors.emergencyContact = "Emergency contact name is required";

    if (!formData.emergencyPhone.trim())
      newErrors.emergencyPhone = "Emergency contact phone is required";

    // Resume validation
    
    if (!formData.resume) {
      newErrors.resume = "Resume is required";
    } else if (formData.resume.size > 5 * 1024 * 1024) {
      newErrors.resume = "Resume file size must be less than 5MB";
    }

    return newErrors;
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      Object.values(newErrors).forEach((err) => toast.error(err));
      return;
    }

    setLoading(true);

  try {
      // ✅ Use FormData instead of JSON
      const formPayload = new FormData();
      Object.keys(formData).forEach((key) => {
        formPayload.append(key, formData[key]);
      });

      // localStorage.setItem("jobApplication", JSON.stringify(formPayload));

      const response = await fetch(
        "https://pacificbuilders.vercel.app/api/job-application",
        {
          method: "POST",
          // headers: { "Content-Type": "application/json" },
          body: formPayload, // ✅ no headers needed, browser sets automatically
        }
      );

      if (response.ok) {
        toast.success("Application submitted successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          position: "",
          experience: "",
          previousWork: "",
          certifications: "",
          availableDate: "",
          shiftPreference: "",
          address: "",
          emergencyContact: "",
          emergencyPhone: "",
          resume: null,
          safetyTraining: "",
          workLocation: "",
          expectedSalary: "",
          references: "",
        });

         // ✅ Clear file input manually
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        toast.error("Failed to submit application. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1BB095]/10 to-teal-900/10 py-12 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 ">
          <div className="flex justify-center items-center mb-4">
            <Building2 className="text-[#1BB095] mr-4" size={48} />
            <HardHat className="text-teal-900" size={48} />
          </div>
          <h1 className="text-5xl font-bold text-gray-800 mb-4">
            Join Our Construction Team
          </h1>
          <p className="text-xl text-gray-600">
            Build your career with Pakistan's leading construction company
          </p>
          <div className="w-32 h-1 bg-gradient-to-r from-[#1BB095] to-teal-900 mx-auto mt-4 rounded-full"></div>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 space-y-6"
        >
          {/* Personal Information */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <User className="mr-3 text-[#1BB095]" size={24} />
              Personal Information
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* First Name */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  First Name *
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="Enter first name"
                  className={`w-full px-4 py-2 border-2 rounded-md ${
                    errors.firstName
                      ? "border-red-400 bg-red-50"
                      : "border-gray-200 hover:border-[#1BB095]"
                  }`}
                />
                {errors.firstName && (
                  <p className="text-red-500 text-sm">{errors.firstName}</p>
                )}
              </div>
              {/* Last Name */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Last Name *
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Enter last name"
                  className={`w-full px-4 py-2 border-2 rounded-md ${
                    errors.lastName
                      ? "border-red-400 bg-red-50"
                      : "border-gray-200 hover:border-[#1BB095]"
                  }`}
                />
                {errors.lastName && (
                  <p className="text-red-500 text-sm">{errors.lastName}</p>
                )}
              </div>
            </div>
          </div>

          {/* (keep rest of your sections the same, just ensure every input has an {errors.field && <p>... </p>} block like above) */}

          {/* Contact Information */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <Phone className="mr-3 text-[#1BB095]" size={24} />
              Contact Details
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="your.email@example.com"
                  className={`w-full px-4 py-2 border-2 rounded-md transition-all duration-200 ${
                    errors.email ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-[#1BB095]'
                  }`}
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="+92 300 1234567"
                  className={`w-full px-4 py-2 border-2 rounded-md transition-all duration-200 ${
                    errors.phone ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-[#1BB095]'
                  }`}
                />
                {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Full Address</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  placeholder="Complete address with city"
                  className="w-full px-4 py-2 border-2 border-gray-200 rounded-md hover:border-[#1BB095] transition-all duration-200"
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Preferred Work Location</label>
                <select
                  name="workLocation"
                  value={formData.workLocation}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border-2 border-gray-200 rounded-md hover:border-[#1BB095] transition-all duration-200"
                >
                  <option value="">Select location</option>
                  <option value="lahore">Lahore</option>
                  <option value="karachi">Karachi</option>
                  <option value="islamabad">Islamabad</option>
                  <option value="faisalabad">Faisalabad</option>
                  <option value="rawalpindi">Rawalpindi</option>
                  <option value="multan">Multan</option>
                  <option value="anywhere">Any location</option>
                </select>
              </div>
            </div>
          </div>

          {/* Job Details */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
              <Wrench className="mr-3 text-[#1BB095]" size={24} />
              Job Information
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Position Applied For *</label>
                <select
                  name="position"
                  value={formData.position}
                  onChange={handleInputChange}
                  className={`w-full px-4 py-2 border-2 rounded-md  transition-all duration-200 ${
                    errors.position ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-[#1BB095]'
                  }`}
                >
                  <option value="">Select position</option>
                  {constructionPositions.map(pos => (
                    <option key={pos} value={pos}>{pos}</option>
                  ))}
                </select>
                {errors.position && <p className="text-red-500 text-sm mt-1">{errors.position}</p>}
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Experience Level *</label>
                <select
                  name="experience"
                  value={formData.experience}
                  onChange={handleInputChange}
                  className={`w-full px-4 py-2 border-2 rounded-md  transition-all duration-200 ${
                    errors.experience ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-[#1BB095]'
                  }`}
                >
                  <option value="">Select experience</option>
                  <option value="fresh">Fresh/No Experience</option>
                  <option value="1-2">1-2 Years</option>
                  <option value="3-5">3-5 Years</option>
                  <option value="6-10">6-10 Years</option>
                  <option value="10+">10+ Years</option>
                </select>
                {errors.experience && <p className="text-red-500 text-sm mt-1">{errors.experience}</p>}
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Available Start Date *</label>
                <input
                  type="date"
                  name="availableDate"
                  value={formData.availableDate}
                  onChange={handleInputChange}
                  className={`w-full px-4 py-2 border-2 rounded-md transition-all duration-200 ${
                    errors.availableDate ? 'border-red-400 bg-red-50' : 'border-gray-200 hover:border-[#1BB095]'
                  }`}
                />
                {errors.availableDate && <p className="text-red-500 text-sm mt-1">{errors.availableDate}</p>}
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Shift Preference</label>
                <select
                  name="shiftPreference"
                  value={formData.shiftPreference}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border-2 border-gray-200 rounded-xl  hover:border-[#1BB095] transition-all duration-200"
                >
                  <option value="">Select shift</option>
                  <option value="day">Day Shift (8 AM - 6 PM)</option>
                  <option value="night">Night Shift (6 PM - 6 AM)</option>
                  <option value="flexible">Flexible</option>
                  <option value="overtime">Available for Overtime</option>
                </select>
              </div>
            </div>
            
            <div className="mt-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">Expected Monthly Salary (PKR)</label>
              <input
                type="text"
                name="expectedSalary"
                value={formData.expectedSalary}
                onChange={handleInputChange}
                placeholder="e.g., 30,000 - 50,000"
                className="w-full px-4 py-2 border-2 border-gray-200 rounded-xl  hover:border-[#1BB095] transition-all duration-200"
              />
            </div>
          </div>

          {/* Safety & Certifications */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
              <Shield className="mr-3 text-[#1BB095]" size={24} />
              Safety & Qualifications
            </h2>
            
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Safety Training & Certifications</label>
                <textarea
                  name="safetyTraining"
                  value={formData.safetyTraining}
                  onChange={handleInputChange}
                  placeholder="List any safety certifications, training courses, or safety-related experience you have..."
                  rows={3}
                  className="w-full px-4 py-2 border-2 border-gray-200 rounded-xl hover:border-[#1BB095] transition-all duration-200 resize-none"
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Professional Certifications & Skills</label>
                <textarea
                  name="certifications"
                  value={formData.certifications}
                  onChange={handleInputChange}
                  placeholder="List relevant certifications, technical skills, equipment you can operate..."
                  rows={3}
                  className="w-full px-4 py-2  border-2 border-gray-200 rounded-md  hover:border-[#1BB095] transition-all duration-200 resize-none"
                />
              </div>
            </div>
          </div>

          {/* Experience Details */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
              <FileText className="mr-3 text-[#1BB095]" size={24} />
              Work Experience
            </h2>
            
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Previous Construction Work Experience</label>
                <textarea
                  name="previousWork"
                  value={formData.previousWork}
                  onChange={handleInputChange}
                  placeholder="Describe your previous construction experience, projects worked on, companies, duration..."
                  rows={4}
                  className="w-full px-4 py-2  border-2 border-gray-200 rounded-md  hover:border-[#1BB095] transition-all duration-200 resize-none"
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">References (Name, Position, Contact)</label>
                <textarea
                  name="references"
                  value={formData.references}
                  onChange={handleInputChange}
                  placeholder="Provide 2-3 professional references from previous employers or supervisors..."
                  rows={3}
                  className="w-full px-4 py-2  border-2 border-gray-200 rounded-md  hover:border-[#1BB095] transition-all duration-200 resize-none"
                />
              </div>
            </div>
          </div>

          {/* Emergency Contact */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
              <MapPin className="mr-3 text-[#1BB095]" size={24} />
              Emergency Contact
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Emergency Contact Name</label>
                <input
                  type="text"
                  name="emergencyContact"
                  value={formData.emergencyContact}
                  onChange={handleInputChange}
                  placeholder="Full name of emergency contact"
                  className="w-full px-4 py-2  border-2 border-gray-200 rounded-md  hover:border-[#1BB095] transition-all duration-200"
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Emergency Contact Phone</label>
                <input
                  type="tel"
                  name="emergencyPhone"
                  value={formData.emergencyPhone}
                  onChange={handleInputChange}
                  placeholder="+92 300 1234567"
                  className="w-full px-4 py-2  border-2 border-gray-200 rounded-md  hover:border-[#1BB095] transition-all duration-200"
                />
              </div>
            </div>
          </div>
            {/* Resume Upload */}
        <div>
  <label className="block text-sm font-semibold text-gray-700 mb-2">
    Upload Resume/CV
  </label>
  <input
    type="file"
    name="resume"
    ref={fileInputRef} // 👈 attach ref here
    onChange={handleInputChange}
    accept=".pdf,.doc,.docx"
    className="w-full px-4 py-2 border-2 border-gray-200 rounded-xl 
               focus:outline-none focus:ring-2 focus:ring-[#1BB095] 
               hover:border-[#1BB095] transition-all duration-200 
               file:mr-4 file:py-2 file:px-4 file:border-0 
               file:bg-gradient-to-r file:from-[#1BB095] file:to-teal-900 
               file:text-white file:rounded-lg file:text-sm file:font-medium 
               file:cursor-pointer"
  />
  <p className="text-xs text-gray-500 mt-1">
    Accepted formats: PDF, DOC, DOCX (Max 5MB)
  </p>
</div>

          {/* Submit Button */}
          <div className="pt-4 w-[40%] mx-auto">
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-[#1BB095] to-teal-900 
                   hover:from-teal-700 hover:to-teal-900 text-white 
                   font-bold py-3 px-8 rounded-xl transition-all 
                   duration-200 transform hover:scale-[1.02] 
                   shadow-lg hover:shadow-xl text-lg disabled:opacity-70"
            >
              {loading ? "Submitting..." : "Submit Job Application"}
            </button>
          </div>
        </form>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default JobApplicationForm;
